import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["aria-label"]
const _hoisted_2 = { class: "modal-header" }
const _hoisted_3 = { class: "modal-title" }
const _hoisted_4 = { class: "modal-body" }

import {onMounted, ref, watch} from "vue";
import {Modal} from "bootstrap";


export default /*@__PURE__*/_defineComponent({
  __name: 'FormModal',
  props: /*@__PURE__*/_mergeModels({
    title: {},
    width: { default: 750 }
  }, {
    "modelValue": {type: Boolean},
    "modelModifiers": {},
  }),
  emits: /*@__PURE__*/_mergeModels(["submit"], ["update:modelValue"]),
  setup(__props: any, { emit: __emit }) {

const model = _useModel(__props, "modelValue");

const props = __props;

const modalFormElement = ref<HTMLElement>();
let modelObject: Modal;

const emit = __emit;

onMounted(() => {
    modelObject = new Modal(modalFormElement.value!);

    modalFormElement.value!.addEventListener("hidden.bs.modal", (event) => {
        model.value = false;
    });
});

const submit = function () {
    emit("submit");
};

function _show() {
    modelObject.show();
    model.value = true;
}

function _hide() {
    modelObject.hide();
    model.value = false;
}

watch(
    () => model.value,
    (showModal, prevShowModal) => {
        if (showModal) {
            _show();
        } else {
            _hide();
        }
    }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "modal fade",
    "data-bs-backdrop": "static",
    "data-bs-keyboard": "false",
    tabindex: "-1",
    "aria-label": _ctx.title,
    ref_key: "modalFormElement",
    ref: modalFormElement
  }, [
    _createElementVNode("div", {
      class: "modal-dialog modal-dialog-centered modal-dialog-scrollable",
      style: _normalizeStyle({maxWidth: `${_ctx.width}px`})
    }, [
      _createElementVNode("form", {
        class: "modal-content",
        onSubmit: _withModifiers(submit, ["prevent"])
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h4", _hoisted_3, _toDisplayString(_ctx.title), 1),
          _cache[0] || (_cache[0] = _createElementVNode("button", {
            type: "button",
            class: "btn-close",
            "data-bs-dismiss": "modal",
            "aria-label": "Close"
          }, null, -1))
        ]),
        _createElementVNode("div", _hoisted_4, [
          _renderSlot(_ctx.$slots, "default")
        ]),
        _cache[1] || (_cache[1] = _createElementVNode("div", { class: "modal-footer" }, [
          _createElementVNode("div", { class: "button-wrapper" }, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-secondary",
              "data-bs-dismiss": "modal"
            }, " Cancel "),
            _createElementVNode("button", {
              class: "btn btn-primary",
              type: "submit"
            }, " Save ")
          ])
        ], -1))
      ], 32)
    ], 4)
  ], 8, _hoisted_1))
}
}

})